<header class="logo">
    <img src="/assets/logos/logo2-full-white.svg" alt="" srcset="">
    <h1>
      Connecting International Communities Overseas
    </h1>
</header>

<section class="video-options" *ngIf="selectedVideo">
  <div class="close">
    <i class="fa-solid fa-xmark" (click)="selectedVideo = null"></i>
  </div>
  <article class="work" *ngIf="isVideoLive(selectedVideo?.pro)">
    <h2>
      Working Overseas
    </h2>
    <div class="items">
        <a class="normal" data-type="normal" target="_blank" *ngIf="selectedVideo.pro.url" [href]="selectedVideo.pro.url" data-video-type="normal" data-video-group="work">
            <label>Watch Normal Video</label>
        </a>

        <a class="v360" data-type="360" target="_blank" *ngIf="selectedVideo.pro.url360" [href]="selectedVideo.pro.url360" data-video-type="360" data-video-group="work">
            <img src="https://res.cloudinary.com/dwko3iqjs/image/upload/v1754567703/Title_360_rusrnh.png">
            <label>
              Watch 360° Video
              <span>Open it using the YouTube APP</span>
            </label>

        </a>
      </div>
  </article>
  <article class="life" *ngIf="isVideoLive(selectedVideo?.liv)">
    <h2>
      Living Overseas
    </h2>
    <div class="items">
        <a class="normal" data-type="normal" target="_blank" *ngIf="selectedVideo.liv.url" [href]="selectedVideo.liv.url" data-video-type="normal" data-video-group="living">
            <label>Watch Normal Video</label>
        </a>

        <a class="v360" data-type="360" target="_blank" *ngIf="selectedVideo.liv.url360" [href]="selectedVideo.liv.url360" data-video-type="360" data-video-group="living">
            <img src="https://res.cloudinary.com/dwko3iqjs/image/upload/v1754567703/Title_360_rusrnh.png">
            <label>
              Watch 360° Video
              <span>Open it using the YouTube APP</span>
            </label>

        </a>
      </div>
  </article>
  <article class="quick" *ngIf="isVideoLive(selectedVideo?.qui)">
    <h2>
      Quick Talk
    </h2>
    <a class="normal" data-type="normal" target="_blank" *ngIf="selectedVideo.qui.url" [href]="selectedVideo.qui.url" data-video-type="normal" data-video-group="quick">
        <label>Watch Video</label>
    </a>
  </article>
</section>

<main>
  <div class="store">
    <a href="https://play.google.com/store/apps/details?id=app.nagringa.app" target="_blank">
        <img
            src="https://res.cloudinary.com/nagringaapp/image/upload/v1702356562/images/download-google_l5k4bb.png">
    </a>
    <a href="https://apps.apple.com/us/app/nagringa/id1608557362" target="_blank">
        <img
            src="https://res.cloudinary.com/nagringaapp/image/upload/v1702356562/images/download-apple_l894gg.png">
    </a>
  </div>
  <a [href]="url" class="link" target="_blank">
    <i class="fa-solid fa-download"></i>
    <label>Download APP</label>
  </a>

  <h3>
    Walk'n'Talk: The Interactive Podcast, tap to watch
  </h3>
  <div class="embeded-info" *ngIf="isEmbeded">
    <i class="fa-solid fa-warning"></i>
    <label>
      You are on Instagram. For an <b>imersive</b> experience open it on the <b>YouTube APP</b>.
    </label>
  </div>
  <app-video-thumb class="youtube" [video]="videoMain" (videoSelected)="selectedVideo = $event"></app-video-thumb>

  <section class="video-list latest">
    <app-video-thumb class="youtube" [video]="video" *ngFor="let video of videosLatest" (videoSelected)="selectedVideo = $event"></app-video-thumb>
  </section>
  <section class="video-list older">
    <app-video-thumb class="youtube" [video]="video" *ngFor="let video of videosList" (videoSelected)="selectedVideo = $event"></app-video-thumb>
  </section>

  <h3>
    Follow and support our social media channels
  </h3>
  <div class="social">

    <a href="https://www.youtube.com/@nagringaapp" class="link" target="_blank">
      <img height="30px" src="https://res.cloudinary.com/dwko3iqjs/image/upload/v1753689141/ico-youtube_unm2iy.png">
      <label>YouTube</label>
    </a>
    <a href="https://www.instagram.com/nagringa.app?igsh=dWN0aDF6OWkzeXM3" class="link" target="_blank">
      <img height="30px" src="https://res.cloudinary.com/dwko3iqjs/image/upload/v1753689144/ico-insta_xl7mc5.png">
      <label>Instagram</label>
    </a>
    <a href="https://www.tiktok.com/@nagringa.app" class="link" target="_blank">
      <img height="30px" src="https://res.cloudinary.com/dwko3iqjs/image/upload/v1753689142/ico-tiktok_ly8xcx.png">
      <label>TikTok</label>
    </a>
    <a href="https://open.spotify.com/show/2dYG9DvyXpdF913rW3a53J?si=5abe9acdb1a84e31" class="link" target="_blank">
      <img height="30px" src="https://res.cloudinary.com/dwko3iqjs/image/upload/v1753758593/Spotify_Primary_Logo_RGB_Green_h7equr.png">
      <label>Spotify</label>
    </a>

  </div>

  <a href="/site" class="link" target="_blank">
    <i class="fa-solid fa-globe"></i>
    <label>Website</label>
  </a>
  <a href="https://shop.nagringa.app" class="link" target="_blank">
    <i class="fa-brands fa-shopify"></i>
    <label>Shop / Store</label>
  </a>
</main>

